import React from "react";
import { Row, Col, Typography } from "antd";
import styles from "./SplitView.module.css";
import { Link, useHistory, useLocation } from "react-router-dom";
import SignupLogo from "assets/images/login-signup/Guni.png";
import useWindowWidth from "hooks/useWindowWidth";
import styless from "../Common/auth.module.css";
import LogoSlideshow from "./LogoSlideshow";

const SplitView = ({ leftContent, rightContent, title, subtitle, tagline, heroImage, features = [], logoImages = [] }) => {
  const history = useHistory();
  const location = useLocation();
  const { width } = useWindowWidth();

  return (
    <Row className={styles.splitContainer}>
      <Col xs={24} sm={24} md={12} lg={12} className={styles.leftSection}>
        <div className={styles.leftContent}>
          {title && (
            <Typography.Title level={1} className={styles.title}>
              {title}
            </Typography.Title>
          )}

          {subtitle && <Typography.Paragraph className={styles.subtitle}>{subtitle}</Typography.Paragraph>}

          {heroImage && (
            <Col className={styles.imageWrapper} span={24}>
              <img src={heroImage} alt="hero" className={styles.heroImage} />
            </Col>
          )}

          <Col span={24}>{tagline && <div className={styles.tagline}>{tagline}</div>}</Col>

          {features?.length > 0 && (
            <div className={styles?.featuresList}>
              {features.map((feature, index) => (
                <div key={index} className={styles.featureCard}>
                  <span className={styles.featureIcon}>{feature.icon}</span>
                  <div className={styles.featureContent}>
                    <div className={styles.featureTitle}>{feature.title}</div>
                    <div className={styles.featureDescription}>{feature.description}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {leftContent}

          {logoImages.length > 0 && (
            <div className={styles.partnersSection}>
              <span className={styles.partnersText}>Trusted by 2000+ Australian Businesses</span>
              <LogoSlideshow images={logoImages} interval={3000} />
            </div>
          )}
        </div>
      </Col>

      <Col xs={24} sm={24} md={12} lg={12} className={styles?.rightSection}>
        <div className={styles?.rightContent}>
          <div className="py-3  pt-0 ms-2">
            <img
              src={SignupLogo}
              alt="social-icon"
              className={`img-fluid mb-2 ${styless?.guniLogo}`}
              onClick={() => {
                history.push("/");
              }}
            />
          </div>
          <div className="px-3">{rightContent}</div>
        </div>
      </Col>
    </Row>
  );
};
export default SplitView;
